import { Button } from "reactstrap";
import React from "react"; // needed for JSX in `Cell`

const TransactionReportColumns = () => [
  {
    Header: "Title",
    accessor: "title",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Transaction Date",
    accessor: "received_date",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Notes",
    accessor: "notes",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Payment Type",
    accessor: "payment_type",
    disableFilters: true,
    filterable: false,
    Cell: ({ value }) => (value === 1 ? "Cash" : value === 2 ? "Online" : "Other"),
  },
  {
    Header: "Transcation Type",
    accessor: "transaction_type",
    disableFilters: true,
    filterable: false,
    Cell: ({ value }) => (value === 1 ? "Income" : value === 2 ? "Expense" : "Other"),
  },
  {
    Header: "Amount",
    accessor: "amount",
    disableFilters: true,
    filterable: false,
  }
];

export default TransactionReportColumns;


